// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

  //const baseUrl = 'http://198.58.98.34:4400'; // local stable
  const baseUrl = 'https://api.14all.us'; // live server
// const baseUrl = 'http://192.168.15.180:4400'; // local stable Prakash

export const environment = {
    //production: false,
    production: true,
    encryption: false,
    baseUrl,
    // apiSecretKey: 'ungwlshftmsu',
    apiSecretKey: 'acwa3pdd2k5eluh5',
    baseApiUrl: `${baseUrl}/api/`,
    //stripeKey : 'pk_test_6VStk200abudJexqNo5oLIuI' // nikhil's sandbox
    stripeKey : 'pk_live_QcWzoRjdTPE0pAvGqS7u2TE900NLpxcGMT' // live
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
